/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_XriskInputs */

const en_learn_xrisk = /** @type {(inputs: Learn_XriskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[X-risk](/xrisk). Why AI is an existential risk.`)
};

/**
* | output |
* | --- |
* | "[X-risk](/xrisk). Why AI is an existential risk." |
*
* @param {Learn_XriskInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const learn_xrisk = /** @type {((inputs?: Learn_XriskInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_XriskInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_learn_xrisk(inputs)
});